<template>
  <div id="app">
	<div class="container">
		<div class="navi-bar">
			<img class="web_logo" v-if="!isBlack" src="@/assets/hudou_web_logo.png"/>
			<img class="web_logo" v-if="isBlack" src="@/assets/hudou_web_logo2.png"/>
			<div class="navi_menu">
			   <div class="navi-item" v-bind:class='{itemSel:naviIndex==0}' @click="naviItemClick(0)">Home</div>
			   <div class="navi-item" v-bind:class='{itemSel:naviIndex==1}' @click="naviItemClick(1)">Contact us</div>
			   <div class="navi-item" v-bind:class='{itemSel:naviIndex==2}' @click="naviItemClick(2)">About us</div>
		   </div>
		</div>
		
		<home-page class="home-page" v-if="naviIndex==0" v-on:carouselChange="carouselChange"></home-page>
		<contact-us-page class="contact-page" v-if="naviIndex==1" ></contact-us-page>
		<about-me-page class="about-page" v-if="naviIndex==2"></about-me-page>
	</div>
	
	
	<div class="bottom-menu">
		<!-- <div class="link_label" @click="linkClick">深圳市互逗科技有限公司  ICP备案号：粤ICP备2023021638号-1</div> -->
	</div>
	
  </div>
</template>

<script>
	
	import Vue from 'vue'
	import HomePage from './components/HomePage.vue'
	import ContactUsPage from './components/ContactUsPage.vue'
	import AboutMePage from './components/AboutMePage.vue'

	
	export default {
		name: 'app',

		components: {
			HomePage,
			ContactUsPage,
			AboutMePage
		},
		
		data(){
			return{
				clientWidth:0,
				naviIndex:0,
				isBlack:false,
			}
		},
	
  
		computed:{
		  imgWidth(){
			  return this.$data.clientWidth;
		  },
		 
		  imgHeight(){
			  var clientWidth = this.$data.clientWidth;
			  var imgHeight = clientWidth*0.36;
			  console.log("clientWidth:" + clientWidth);
			  console.log("imgHeight:" + imgHeight);
			  return imgHeight;
		  }
	},
  
 
	mounted() {
		var clientWidth = document.documentElement.clientWidth;//获取浏览器可视区域高度
		this.$data.clientWidth = clientWidth;
		
		let that = this;
		window.onresize = function(){
			var clientWidth = document.documentElement.clientWidth;//获取浏览器可视区域高度
			that.$data.clientWidth = clientWidth;
		}
	},
  
  
	beforeDestroy() {
		if( this.$data.isAgree ){
			///发送退出
			this.endControl();
		}
	},

	created() {
		window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
	},

	destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
	},


	methods:{
		beforeunloadFn(e) {
			console.log('刷新或关闭')
		}, 
		
		carouselChange(res){
			console.log(res);
			var index = res;
			if( index == 0 ){
				this.$data.isBlack = false;
			}
			else{
				this.$data.isBlack = true;
			}
		},
		
		naviItemClick(res){
			console.log(res);
			var index = res;
			this.$data.naviIndex = index;
			this.$data.isBlack = false;
		},
		
		linkClick() {
		    location.href="https://beian.miit.gov.cn/"
		}
	}

}
</script>



<style>
	#app {
	/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 60px; */
	  padding: 0;
	  margin: 0;
	}

	.container{
		padding: 0;
		margin: 0;
		width: 100vw;
		height: 100vh;
		position: relative;
	}
	
	.navi-bar{
		position: fixed;
		width: 100vw;
		height: 60px;
		display: flex;
		align-items: center;
		z-index: 1000;
	}
	
	.web_logo{
		width: 34px;
		height: 34px;
		margin-left: 50px;
	}
	
	.navi_menu{
		position: absolute;
		height: 100;
		right: 50px;
		display: flex;
		align-items: center;
	}

	.navi-item{
		padding-left: 30px;
		padding-right: 30px;
		color: #666666;
	}

	.itemSel{
		color: #ED47FF;
	}
	
	.home-page{
		width: 100%;
		height: 100%;
		z-index: 100;
	}
	
	.contact-page{
		width: 100%;
		height: fit-content;
		z-index: 100;
	}
	
	.about-page{
		width: 100%;
		height: 100%;
		z-index: 100;
	}
	
	.bottom-menu{
		position: fixed;
		bottom: 0;
		width: 100vw;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 3000;
		background-color: white;
	}
	
	.link_label{
		color: #919191;
		font-size: 17px;
	}
	
	

</style>

>